import { useState } from 'react'

import { ClickAwayListener } from '@mui/material'

import { StyledTooltip, TooltipContent, TooltipSelf } from '~/core/components/tooltip/common'
import type { TooltipPropsType } from '~/core/components/tooltip/common'

export const MobileTooltip = (props: TooltipPropsType) => {
  const [open, setOpen] = useState(false)

  function handleTooltipClose() {
    setOpen(false)
  }

  function handleTooltipOpen() {
    setOpen(true)
  }

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <StyledTooltip
        placement="bottom"
        arrow
        PopperProps={{ disablePortal: true }}
        open={open}
        disableHoverListener
        title={<TooltipContent>{props.content}</TooltipContent>}
      >
        <TooltipSelf onClick={handleTooltipOpen}>{props.self}</TooltipSelf>
      </StyledTooltip>
    </ClickAwayListener>
  )
}
